var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstChristmas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6126 8.21546V7.71546H34.1126H31.0552C30.4229 5.67071 29.5406 3.9283 28.4718 2.6677C27.3411 1.33409 25.9637 0.5 24.4336 0.5C22.9036 0.5 21.5262 1.33409 20.3955 2.6677C19.3267 3.9283 18.4443 5.67071 17.8121 7.71546H14.7547H14.2547V8.21546V16.2626C6.13134 20.0325 0.5 28.2449 0.5 37.7837C0.5 50.8786 11.1152 61.5 24.2163 61.5C37.3172 61.5 47.9325 50.8847 47.9325 37.7837C47.9325 28.4156 42.4999 20.3193 34.6126 16.4688V8.21546ZM27.689 7.71546H21.1721C21.5548 6.4728 22.0343 5.45803 22.5679 4.73475C23.193 3.88748 23.8341 3.51194 24.4306 3.51067C25.0239 3.51194 25.665 3.88716 26.2912 4.73496C26.8254 5.45832 27.3061 6.47308 27.689 7.71546Z",
    fill: "#F2AE1D",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8574 45H24.0494V32.64L21.4334 35.352L19.8014 33.648L24.4094 28.992H26.8574V45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstChristmas);
export default __webpack_public_path__ + "static/media/firstChristmas.d140dfe4980a65928ff478a1ca98b9d5.svg";
export { ForwardRef as ReactComponent };